var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8001 1.39998C7.8001 0.958148 7.44193 0.599976 7.0001 0.599976C6.55827 0.599976 6.2001 0.958148 6.2001 1.39998V2.19998C6.2001 2.6418 6.55827 2.99998 7.0001 2.99998C7.44193 2.99998 7.8001 2.6418 7.8001 2.19998V1.39998Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5255 3.60582C11.838 3.2934 11.838 2.78687 11.5255 2.47445C11.2131 2.16203 10.7066 2.16203 10.3942 2.47445L9.82849 3.04014C9.51607 3.35255 9.51607 3.85909 9.82849 4.17151C10.1409 4.48393 10.6474 4.48393 10.9599 4.17151L11.5255 3.60582Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4001 6.99998C13.4001 7.4418 13.0419 7.79998 12.6001 7.79998H11.8001C11.3583 7.79998 11.0001 7.4418 11.0001 6.99998C11.0001 6.55815 11.3583 6.19998 11.8001 6.19998H12.6001C13.0419 6.19998 13.4001 6.55815 13.4001 6.99998Z",
    fill: "#9CA3AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04025 4.17152C3.35267 4.48394 3.8592 4.48394 4.17162 4.17152C4.48404 3.8591 4.48404 3.35257 4.17162 3.04015L3.60593 2.47446C3.29351 2.16204 2.78698 2.16204 2.47456 2.47446C2.16214 2.78688 2.16214 3.29342 2.47456 3.60583L3.04025 4.17152Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0001 6.99998C3.0001 7.4418 2.64193 7.79998 2.2001 7.79998H1.4001C0.95827 7.79998 0.600098 7.4418 0.600098 6.99998C0.600098 6.55815 0.95827 6.19998 1.4001 6.19998H2.2001C2.64193 6.19998 3.0001 6.55815 3.0001 6.99998Z",
    fill: "#9CA3AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4001 11.8V11H8.6001V11.8C8.6001 12.6836 7.88375 13.4 7.0001 13.4C6.11644 13.4 5.4001 12.6836 5.4001 11.8Z",
    fill: "#9CA3AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60081 10.2C8.61249 9.92771 8.76617 9.68294 8.98155 9.51288C9.72374 8.92686 10.2001 8.01904 10.2001 6.99998C10.2001 5.23266 8.76741 3.79998 7.0001 3.79998C5.23279 3.79998 3.8001 5.23266 3.8001 6.99998C3.8001 8.01904 4.27646 8.92686 5.01865 9.51288C5.23402 9.68294 5.38771 9.92771 5.39938 10.2H8.60081Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.1dbe4bfe3dab0f7473dba82a3b95ac68.svg";
export { ForwardRef as ReactComponent };